import React from "react";
import { useAuth } from "../contexts/AuthContext";
import TabLabelWithCount from "./TabLabelWithCount";
import TabsList from "./TabsList";

export const STOCK_TAB_HOLDINGS = "list";
export const STOCK_TAB_DAILY_NEWS = "daily-news";
export const STOCK_TAB_ARK_BUY = "ark-buy";
export const STOCK_TAB_BUY_LIST = "buy-recommendation";
export const STOCK_TAB_QUICK_ANALYSIS = "quick-analysis";

/**
 * Top-level Stock section tabs (data-source groups on StockManagement).
 * Holdings = Barchart, Daily News = in-app, ARK ETF = Cathie's Ark, Buy List = Yahoo Finance.
 */
export default function StockSectionTabs({
  activeTab,
  holdingsCount,
  dailyNewsCount,
  arkEtfCount,
  buyListCount,
  quickAnalysisCount,
  onSelectTab,
}) {
  const { hasPermission } = useAuth();
  const showStock = hasPermission && hasPermission("menu.stock_management");

  if (!showStock) return null;

  return (
    <TabsList className="section-tabs-list" role="tablist" aria-label="Stock sections">
      <button
        type="button"
        role="tab"
        aria-selected={activeTab === STOCK_TAB_HOLDINGS}
        className={`tab-btn ${activeTab === STOCK_TAB_HOLDINGS ? "active" : ""}`}
        onClick={() => {
          if (onSelectTab) onSelectTab(STOCK_TAB_HOLDINGS);
        }}
      >
        <TabLabelWithCount label="Holdings" count={holdingsCount} />
      </button>
      <button
        type="button"
        role="tab"
        aria-selected={activeTab === STOCK_TAB_DAILY_NEWS}
        className={`tab-btn ${activeTab === STOCK_TAB_DAILY_NEWS ? "active" : ""}`}
        onClick={() => {
          if (onSelectTab) onSelectTab(STOCK_TAB_DAILY_NEWS);
        }}
      >
        <TabLabelWithCount label="Daily News" count={dailyNewsCount} />
      </button>
      <button
        type="button"
        role="tab"
        aria-selected={activeTab === STOCK_TAB_ARK_BUY}
        className={`tab-btn ${activeTab === STOCK_TAB_ARK_BUY ? "active" : ""}`}
        onClick={() => {
          if (onSelectTab) onSelectTab(STOCK_TAB_ARK_BUY);
        }}
      >
        <TabLabelWithCount label="ARK ETF" count={arkEtfCount} />
      </button>
      <button
        type="button"
        role="tab"
        aria-selected={activeTab === STOCK_TAB_BUY_LIST}
        className={`tab-btn ${activeTab === STOCK_TAB_BUY_LIST ? "active" : ""}`}
        onClick={() => {
          if (onSelectTab) onSelectTab(STOCK_TAB_BUY_LIST);
        }}
      >
        <TabLabelWithCount label="Buy List" count={buyListCount} />
      </button>
      <button
        type="button"
        role="tab"
        aria-selected={activeTab === STOCK_TAB_QUICK_ANALYSIS}
        className={`tab-btn ${activeTab === STOCK_TAB_QUICK_ANALYSIS ? "active" : ""}`}
        onClick={() => {
          if (onSelectTab) onSelectTab(STOCK_TAB_QUICK_ANALYSIS);
        }}
      >
        <TabLabelWithCount label="Quick Analysis" count={quickAnalysisCount} />
      </button>
    </TabsList>
  );
}
